export enum AccountUsageType {
  PlatformSharedServices = 'Platform Shared Services',
  PlatformInfrastructure = 'Platform Infrastructure',
  DevOps = 'DevOps',
  ITOps = 'ITOPS',
  FuseApp = 'Fuse App',
  NonFuseApp = 'Non-Fuse App',
  Developer = 'Developer',
}

export enum Environment {
  Sandbox = 'sandbox',
  DTS = 'dts',
  Prod = 'prod',
}

export enum ApplicationCategory {
  Agile = 'Agile',
  BIReporting = 'BI and Reporting',
  DeveloperTools = 'Developer Tools',
  DocumentManagement = 'Document Management',
  ITSM = 'ITSM',
  PPM = 'PPM',
  Publishing = 'Publishing',
  TimeTracking = 'Time Tracking',
  VisualCollaboration = 'Visual Collaboration',
  ServiceRocket = 'Service Rocket',
}

export enum Brand {
  Appfire = 'Appfire',
}

export interface FormData {
  account_usage: AccountUsageType;
  environment: string[];
  admin_email: string;
  brand: string;
  change_reason?: string;
  custom_fields?: {
    budget?: number;
  };
  application_name?: string;
  team_members?: string[];
  application_category?: string;
  _errors?: {
    admin_email?: string;
  };
}

export interface AccountTypeFields {
  environment: string[];
  admin_email: string;
  application_category?: ApplicationCategory;
}
